import * as React from "react";
type Props = {
  className?: string,
};
function SvgFoodQualities({ className }: Props) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-FoodQualities"
      className={className}
    >
      <path
        d="M19.9043 5.37403L19.9045 5.37396C22.7396 4.05844 25.3378 3.5 27.7579 3.5C35.1055 3.5 40.9821 8.65272 46.9975 14.1843C47.202 14.3724 47.4066 14.5609 47.6115 14.7495C50.3938 17.3117 53.2099 19.905 56.1884 21.9804C59.3916 24.2123 62.8175 25.8714 66.6487 26.2596C70.7673 26.677 73.343 29.0478 74.5969 32.5482C75.8631 36.0831 75.7785 40.783 74.4642 45.7546C71.8345 55.7013 64.3534 66.4808 53.5641 70.7804C31.9256 79.4035 13.2396 65.7558 6.5059 54.2283C3.17166 48.5203 1.47365 38.6236 3.16034 28.9657C4.84429 19.3236 9.88165 10.0209 19.9043 5.37403Z"
        fill="#D6E4EE"
        stroke="currentColor"
      />
      <mask
        id="mask0_110_40249"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={3}
        y={16}
        width={74}
        height={49}
      >
        <path d="M77 16H3V65H77V16Z" fill="white" />
      </mask>
      <g mask="url(#mask0_110_40249)">
        <path
          d="M72.7685 47.9489H27.9883C28.0009 47.9489 28.0261 47.9363 28.0386 47.9237C29.1969 47.2191 29.0835 44.9169 30.0277 43.9358C30.9467 42.9671 33.2632 42.9797 33.9305 41.7845C34.5725 40.627 33.3387 38.6771 33.6787 37.3437C34.006 36.0605 36.0329 34.9533 36.0329 33.5696C36.0329 32.1856 34.006 31.0786 33.6787 29.7955C33.3387 28.4745 34.5725 26.5245 33.9305 25.3546C33.8045 25.1155 33.6031 24.9268 33.3639 24.7634C37.0274 22.8385 41.2071 21.7439 45.6259 21.7439C59.8141 21.7439 71.3711 32.9908 71.8495 47.0431C71.8746 47.5462 72.2649 47.9489 72.7685 47.9489Z"
          fill="white"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.8714 21.7378C44.8986 21.6914 46.0164 21.6759 47.1873 21.7002C47.8757 21.1862 48.3279 20.3728 48.3279 19.4479C48.3279 17.891 47.0645 16.6289 45.5065 16.6289C43.9486 16.6289 42.6855 17.891 42.6855 19.4479C42.6855 20.394 43.1558 21.2265 43.8714 21.7378Z"
          fill="white"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.8322 44.4139C64.8322 44.4139 65.3213 36.8226 58.6699 31.9336"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M76.3693 49.5212C76.3693 50.3766 75.6643 51.0811 74.7957 51.0811H27.8123L27.271 49.4079C27.0947 48.8922 27.0098 48.4211 27.0098 48.4211C27.0098 48.4211 27.4725 48.238 27.9886 47.9487H74.7957C75.6643 47.9487 76.3693 48.6532 76.3693 49.5212Z"
          fill="white"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.9314 41.7842C33.2641 42.9794 30.9476 42.9669 30.0286 43.9356C29.0844 44.9167 29.1978 47.2189 28.0395 47.9234C28.027 47.936 28.0018 47.9486 27.9892 47.9486C27.473 48.2379 26.8058 48.1624 26.1008 48.0368C25.9497 48.0116 25.7986 47.9738 25.6476 47.9486C25.0307 47.8228 24.4138 47.6971 23.885 47.7473C23.7843 47.7599 23.6836 47.7851 23.5829 47.8103C23.4696 47.8479 23.3563 47.8857 23.243 47.9486C22.5254 48.3135 21.8456 49.1311 21.128 49.6595C20.7251 49.974 20.2971 50.2005 19.8313 50.2005C18.6227 50.2005 17.6408 48.6532 16.5706 48.0242C16.407 47.9234 16.2433 47.8605 16.0796 47.8103C15.979 47.7851 15.8908 47.7599 15.7901 47.7473C14.9466 47.6593 13.8891 48.0368 12.9575 48.1374C12.4665 48.175 12.0007 48.1498 11.6356 47.9234C10.4774 47.2189 10.5907 44.9167 9.64656 43.9356C8.71496 42.9669 6.4111 42.9794 5.7439 41.7842C5.10183 40.6268 6.33556 38.6769 5.9957 37.3435C5.66837 36.0603 3.62891 34.953 3.62891 33.5694C3.62891 32.1854 5.66837 31.0783 5.9957 29.7953C6.33556 28.4743 5.10183 26.5243 5.7439 25.3544C6.4111 24.1591 8.71496 24.1717 9.64656 23.2032C10.5907 22.2345 10.4774 19.9196 11.6356 19.2276C12.7812 18.5358 14.7704 19.7058 16.0796 19.3283C17.3638 18.976 18.4464 16.938 19.8313 16.938C21.2287 16.938 22.3114 18.976 23.5829 19.3283C24.9048 19.7058 26.8939 18.5358 28.0395 19.2276C29.1978 19.9196 29.0844 22.2345 30.0286 23.2032C30.7714 23.983 32.408 24.1215 33.3648 24.7631C33.604 24.9265 33.8054 25.1153 33.9314 25.3544C34.5734 26.5243 33.3396 28.4743 33.6796 29.7953C34.0069 31.0783 36.0338 32.1854 36.0338 33.5694C36.0338 34.953 34.0069 36.0603 33.6796 37.3435C33.3396 38.6769 34.5734 40.6268 33.9314 41.7842Z"
          fill="white"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.7088 62.2778L26.4033 58.6798C25.8242 58.2018 25.1822 58.3905 24.9681 59.1075L23.5204 63.8377C23.3064 64.5422 22.9412 64.5422 22.7146 63.8377L19.9576 55.3836C19.7562 54.7672 19.4288 54.6792 19.177 55.1321V55.1447C19.1393 55.2076 19.1015 55.2832 19.0763 55.3712L16.0549 63.8503C15.8157 64.5547 15.4506 64.5422 15.2492 63.8251L13.9399 59.0697C13.7384 58.3527 13.109 58.1514 12.5173 58.6169L8.09845 62.1268C7.51932 62.5923 7.25499 62.4036 7.49419 61.699L11.8878 49.3829C12.064 48.9175 12.4795 48.4394 12.9579 48.1375C13.1845 47.9865 13.4237 47.8732 13.6503 47.823C13.6503 47.823 14.7834 47.5587 15.7905 47.7474C15.8912 47.76 15.9794 47.7852 16.08 47.8104C16.2437 47.8606 16.4074 47.9236 16.571 48.0243C17.6412 48.6533 18.6231 50.2007 19.8317 50.2007C20.2975 50.2007 20.7255 49.9742 21.1284 49.6597C21.846 49.1312 22.5258 48.3136 23.2434 47.9487C23.3567 47.8858 23.4699 47.848 23.5833 47.8104C23.684 47.7852 23.7847 47.76 23.8854 47.7474C24.7289 47.5965 25.5346 47.7978 25.5346 47.7978C25.6731 47.8354 25.799 47.8858 25.9375 47.9487C25.9878 47.9739 26.0508 48.0117 26.1012 48.0369C26.6299 48.3514 27.0957 48.8923 27.2719 49.408L27.8133 51.0812L31.3258 61.8627C31.565 62.5671 31.2879 62.7558 30.7088 62.2778Z"
          fill="white"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0312 55.562L21.0774 49.8171"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.8362 43.6737C25.4197 43.6737 29.9459 39.1506 29.9459 33.5712C29.9459 27.9917 25.4197 23.4688 19.8362 23.4688C14.2528 23.4688 9.72656 27.9917 9.72656 33.5712C9.72656 39.1506 14.2528 43.6737 19.8362 43.6737Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
export default SvgFoodQualities;
